 
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { AudioControlsComponent } from './components/audio-controls/audio-controls.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TooltipModule } from '@mhe/ngx-shared/tooltip';
import { AlertModule, ButtonModule } from '@mhe/ngx-shared';
import { PageTTSControlsComponent } from './components/page-tts-controls/page-tts-controls.component';
import { FloatingTTSControlsComponent } from './components/floating-tts-controls/floating-tts-controls.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { TtsVoicePickerComponent } from './components/tts-voice-picker/tts-voice-picker.component';

@NgModule({
  imports: [
    CommonModule,
    A11yModule,
    MatSliderModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    TranslateModule,
    TooltipModule,
    ButtonModule,
    AlertModule,
  ],
  declarations: [
    FloatingTTSControlsComponent,
    PageTTSControlsComponent,
    AudioControlsComponent,
    TtsVoicePickerComponent,
  ],
  exports: [
    FloatingTTSControlsComponent,
    PageTTSControlsComponent,
    AudioControlsComponent,
    TtsVoicePickerComponent,
  ],
})
export class TTSModule {}
